"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../utils");
var _SocketEvents = require("../../constants/SocketEvents");
/**
 * Remove attendee from meeting
 * @param {String} sourceId The source id
 */
function removeAttendeeFromMeeting(sourceId) {
  return (0, _utils.withCurrentParams)(function (dispatch, _ref, getState, socket) {
    var broadcastId = _ref.broadcastId;
    var _getState = getState(),
      sources = _getState.broadcastSources.sources;
    var sourceFound = sources.find(function (s) {
      return String(s._id) === sourceId;
    });
    if (sourceFound) {
      socket.emit(_SocketEvents.ATTENDEE_DISMISSED, {
        broadcastId: broadcastId,
        attendeeId: sourceFound.value
      });
    }
  });
}
var _default = exports["default"] = removeAttendeeFromMeeting;